import { Link } from "react-router-dom";
import React, { useState } from "react";
const Bieppsidebar = ({ token, username }) => {
    const [isActive, setIsActive] = useState(false);
    if (username.bedrijf && username.bedrijf.modules.includes("biepp")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "faciliteitmedewerker") {
      return (
        <li className="treeview">
          <a className="cursurhand" onClick={() => setIsActive(!isActive)}>
            <i className="fa fa-swatchbook" />
            <span>Biepp</span>
            <span className="pull-right-container">
              <i className="fa fa-angle-left pull-right" />
            </span>
          </a>
          <ul className={isActive ? "treeview-menu menu-open" : "treeview-menu "}>
            <li>
              <Link to="/biepp" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-search" />
                <span>Activiteiten zoeken</span>
              </Link>
            </li>
            <li>
              <Link to="/biepp/insert" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-plus" />
                <span>Activiteiten toevoegen</span>
              </Link>
            </li>
            <li>
              <Link to="/biepp/beheer" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-swatchbook" />
                <span>Activiteiten beheren</span>
              </Link>
            </li>
          </ul>
        </li>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default Bieppsidebar;
